import { useEffect } from 'react';
import { FULLSTORY_ORG_ID } from 'config';
import * as FullStory from '@fullstory/browser';

export function useIntegrations () {
  useEffect(function init () {
    FullStory.init({
      orgId: FULLSTORY_ORG_ID,
      devMode: process.env.NODE_ENV === 'development'
    });
  }, []);
}
